/**
 * useManifest — resolve o manifest do jogo a partir do slug.
 *
 * Em v1 simples: busca em `/api/modules/module_lab/games/{slug}` via fetch.
 * Cacheia durante o ciclo de vida do componente.
 */

import { useEffect, useState } from 'react'

import type { Manifest } from '../types/manifest'

interface State {
  manifest: Manifest | null
  loading: boolean
  error: string | null
}

export function useManifest(slug: string | null | undefined): State {
  const [state, setState] = useState<State>({
    manifest: null,
    loading: false,
    error: null,
  })

  useEffect(() => {
    if (!slug) {
      setState({ manifest: null, loading: false, error: null })
      return
    }
    let cancelled = false
    setState({ manifest: null, loading: true, error: null })
    fetch(`/api/modules/module_lab/games/${encodeURIComponent(slug)}`)
      .then((r) => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`)
        return r.json()
      })
      .then((data: { manifest: Manifest }) => {
        if (cancelled) return
        setState({ manifest: data.manifest, loading: false, error: null })
      })
      .catch((err: unknown) => {
        if (cancelled) return
        setState({
          manifest: null,
          loading: false,
          error: err instanceof Error ? err.message : String(err),
        })
      })
    return () => {
      cancelled = true
    }
  }, [slug])

  return state
}
